import React, { useState } from 'react'
import ForgetpasswdForm from '../HCT components/Forget password/ForgetpasswdForm'
import { useNavigate } from 'react-router-dom'

const ForgetPasswordHCTPage = () => {

    return (
        <div>
            <ForgetpasswdForm />
        </div>
    )
}

export default ForgetPasswordHCTPage
